/* global _ */
export default {
  methods: {
    setHistoryCrowd () {
      localStorage.__fx_current_domainid = this.$store.state.domainId
      localStorage.__fx_current_accountname = window.$userName
      localStorage.__fx_selected_crowd = JSON.stringify(this.selectedCrowd)
    },
    getHistoryCrowd () {
      try {
        const sameDomain = _.has(localStorage, '__fx_current_domainid') &&
          +localStorage.__fx_current_domainid === this.$store.state.domainId
        const sameAccount = _.has(localStorage, '__fx_current_accountname') &&
          localStorage.__fx_current_accountname === window.$userName
        const hasCrowd = _.has(localStorage, '__fx_selected_crowd')
        this.selectedCrowd = sameDomain && sameAccount && hasCrowd
          ? JSON.parse(localStorage.__fx_selected_crowd) : []
      } catch (e) {
        this.selectedCrowd = []
      }
    },
    backCrowd () {
      clearInterval(this.timer)
      this.resetCrowd()
      this.getTableData(1)
    },
    getCrowdList () {
      this.$store.dispatch('SET_TABLE_LOADING', true)
      const crowdPromise = this.$http.get('/api/crowd/list', {
        params: {
          domainId: this.$store.state.domainId,
          ps: 100,
          pg: 1
        }
      })
      this.$store.dispatch('VUE_HTTP', [crowdPromise])
        .then(res => {
          if (!res.errno) {
            const crowdList = res.list.map(item => {
              if (_.find(this.selectedCrowd, {id: item.id})) {
                item.checked = true
                item.style = _.find(this.selectedCrowd, {id: item.id}).style
              } else {
                item.checked = false
              }
              return item
            })
            this.selectedCrowd = _.filter(crowdList, {checked: true})
            this.preview_crowdList = crowdList
            this.crowdList = crowdList
          } else {
            this.selectedCrowd = []
            this.preview_crowdList = []
            this.crowdList = []
          }
          this.$store.dispatch('SET_TABLE_LOADING', false)
        })
    },
    removeUpdate () {
      this.getCrowdList()
      this.crowdShow = false
      this.preview_crowdList = []
      this.applyCrowd()
    },
    resetCrowd () {
      this.crowdShow = false
      this.crowdList = this.preview_crowdList
      this.selectedCrowd = _.filter(this.crowdList, {checked: true})
      this.preview_crowdList = []
    },
    applyCrowd () {
      this.selectedCrowd = _.filter(this.crowdList, {checked: true})
      if (_.isEmpty(this.selectedCrowd)) {
        this.updatePage(1)
      } else {
        this.heatbeat()
        this.setCompared({compared: false, compStart: '', compEnd: ''})
        this.sdim = 'null'
      }
    },
    showCrowd () {
      if (this.crowdList.length) {
        this.crowdShow = true
        this.currentCrowdType = 'show'
      } else {
        this.openCrowd()
      }
    },
    dropCrowd (item) {
      this.$set(item, 'checked', false)
      this.$set(item, 'style', {})
      const index = _.findIndex(this.selectedCrowd, item)
      this.selectedCrowd.splice(index, 1)
      if (_.isEmpty(this.selectedCrowd)) {
        this.updatePage(1)
      } else {
        this.heatbeat()
      }
    },
    openCrowd () {
      this.isMvSite()
        .then(res => {
          if (res.errno) return
          if (!res.isMv) {
            this.crowdShow = true
            this.currentCrowdType = 'list'
            if (_.isEmpty(this.crowdList)) {
              this.getCrowdList()
            }
          } else {
            this.isMv = true
          }
        })
    },
    getDataWithCrowd () {
      if (_.isEmpty(this.selectedCrowd)) {
        this.getTableData(1)
      } else {
        clearInterval(this.timer)
        this.calcLoading = false
        this.heatbeat()
      }
    },
    updatePage (pn) {
      this.crowdShow = false
      this.getTableData(pn)
    },
    updateCrowdTag (crowd) {
      const maxCrowdNum = 5
      if (crowd.checked && this.crowdTags.length > maxCrowdNum) {
        this.$set(crowd, 'checked', false)
      }
    },

    gotoSetting () {
      this.$store.dispatch('SET_MV_ADDSITE', true)
      this.$router.push('/setting/sites')
    },
    isMvSite () {
      const mvPromise = this.$http.get('/api/crowd/isMv', {
        params: {
          domainId: this.$store.state.domainId
        }
      })
      return this.$store.dispatch('VUE_HTTP', [mvPromise])
    },
    heatbeat () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.clusterid === 0) {
        this.updatePage(1)
      } else {
        this.calcLoading = true
        this.timer = setInterval(() => {
          this.checkStatus()
        }, 800)
      }
    },
    checkStatus () {
      this.calcLoading = true
      const successFlag = 3
      const module = !this.transelected || this.transelected === 'null' ? [this.module] : [this.module, `trans_${this.module}`]
      const statusPromise = this.$http.get('/api/crowd/status', {
        params: {
          domainId: this.$store.state.domainId,
          clusterid: this.clusterid,
          module: module.join(','),
          start: this.start,
          end: this.end
        }
      })
      this.$store.dispatch('VUE_HTTP', [statusPromise])
        .then(res => {
          if (res.errno) {
            clearInterval(this.timer)
            this.backCrowd()
          } else if (res.status >= successFlag) {
            clearInterval(this.timer)
            if (res.success_list.length === 0) {
              _.map(this.selectedCrowd, item => {
                this.$set(item, 'checked', false)
              })
              this.selectedCrowd = []
              this.calcLoading = false
              this.tableDataList = []
              this.total = 0
              this.$Modal.alert('人群数据计算失败， 可稍后重试')
            }
            this.cacheVersion = res.cache_version
            this.updatePage(1)
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pageview/crowdmixin.js